import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";

/**
 * Batch-resolve user_keys -> { user_key: {name, first_name, last_name, avatar_url, hierarchy_level} }
 * Met en cache pendant la session pour éviter de re-fetcher.
 */
const CACHE = new Map();
const INFLIGHT = new Map();

export function useAuthors(keys) {
  const [authors, setAuthors] = useState({});
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!keys || keys.length === 0) return;
    const unique = [...new Set(keys.filter(Boolean))];
    const missing = unique.filter((k) => !CACHE.has(k));

    // hydrate from cache immediately
    const hydrated = {};
    for (const k of unique) {
      if (CACHE.has(k)) hydrated[k] = CACHE.get(k);
    }
    if (Object.keys(hydrated).length) {
      setAuthors((prev) => ({ ...prev, ...hydrated }));
    }

    if (missing.length === 0) return;

    // dedupe in-flight
    const cacheKey = missing.sort().join(",");
    let promise = INFLIGHT.get(cacheKey);
    if (!promise) {
      promise = api
        .get(`/users/lookup?keys=${encodeURIComponent(cacheKey)}`)
        .then((r) => r.data)
        .finally(() => INFLIGHT.delete(cacheKey));
      INFLIGHT.set(cacheKey, promise);
    }

    promise
      .then((data) => {
        for (const k of missing) {
          // mémoriser même si user_key inconnu (évite re-fetch boucle)
          CACHE.set(k, data[k] || { user_key: k, name: "Membre APOLLO", first_name: "M", last_name: "A" });
        }
        if (!mounted.current) return;
        const merged = {};
        for (const k of unique) merged[k] = CACHE.get(k);
        setAuthors((prev) => ({ ...prev, ...merged }));
      })
      .catch(() => {
        // ignore — fallback silencieux
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keys?.join("|")]);

  return authors;
}
